export const KUSHKI_CONSTANTS = {
  G66_CODE_FROM_BANK: '1814',
} as const;

export const KUSHKI_STATUS_LIST = {
  PENDING: 'En proceso',
  NOT_AUTHORIZED: 'Rechazado',
  FAILED: 'Rechazado',
  OK: 'Aprobado',
};
